export default __webpack_public_path__ + "static/media/100secure.9b53d13f.png";